import { render } from "./SelecionarDepartamento.vue?vue&type=template&id=745f1aa9&scoped=true&ts=true"
import script from "./SelecionarDepartamento.vue?vue&type=script&lang=ts"
export * from "./SelecionarDepartamento.vue?vue&type=script&lang=ts"

import "./SelecionarDepartamento.vue?vue&type=style&index=0&id=745f1aa9&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745f1aa9"]])

export default __exports__